import type { Move } from "@dailywars/core/engine";

export const enemyPassTurn: Move[] = [{ type: "endTurn" }];
